"use client";
import React from "react";
import { H1, H4, P } from "@template/components";
import * as S from "./styles.ts";

interface IDeliveryTermsSectionComponentProps {
  definitions?: { text: string }[];
  sections?: {
    title: string;
    content: { text: string }[];
  }[];
}

const DeliveryTermsSectionComponent = ({
                                         definitions,
                                         sections,
                                       }: IDeliveryTermsSectionComponentProps) => {
  return (
    <S.DeliveryTermsSectionWrapper>
      <S.DeliveryTermsSectionContainer>
        <H1>Delivery Terms and Conditions</H1>
        <S.DeliveryTerms>
          <H4>Definitions</H4>
          {definitions?.map((definition, index) => (
            <P key={`definition-${index}`}>{definition.text}</P>
          ))}
          {sections?.map((section, index) => (
            <React.Fragment key={index}>
              <H4 key={`section-${index}`}>{section.title}</H4>

              {section.content?.map((item, i) => (
                <P key={`s-${index}-item-${i}`}>{item.text}</P>
              ))}
            </React.Fragment>
          ))}
        </S.DeliveryTerms>
      </S.DeliveryTermsSectionContainer>
    </S.DeliveryTermsSectionWrapper>
  );
};

export default DeliveryTermsSectionComponent;

export const options = [
  {
    description: "",
    displayName: "DeliveryTermsSectionComponent",
    methods: [],
    props: {
      definitions: {
        required: false,
        flowType: {
          name: "Array",
          elements: [
            {
              name: "signature",
              type: "object",
              raw: "{ text: string }",
              signature: {
                properties: [
                  {
                    key: "text",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                ],
              },
            },
          ],
          raw: "{ text: string }[]",
        },
        description: "",
      },
      sections: {
        required: false,
        flowType: {
          name: "Array",
          elements: [
            {
              name: "signature",
              type: "object",
              raw: "{\n  title: string;\n  content: { text: string }[];\n}",
              signature: {
                properties: [
                  {
                    key: "title",
                    value: {
                      name: "string",
                      required: true,
                    },
                  },
                  {
                    key: "content",
                    value: {
                      name: "Array",
                      elements: [
                        {
                          name: "signature",
                          type: "object",
                          raw: "{ text: string }",
                          signature: {
                            properties: [
                              {
                                key: "text",
                                value: {
                                  name: "string",
                                  required: true,
                                },
                              },
                            ],
                          },
                        },
                      ],
                      raw: "{ text: string }[]",
                      required: true,
                    },
                  },
                ],
              },
            },
          ],
          raw: "{\n  title: string;\n  content: { text: string }[];\n}[]",
        },
        description: "",
      },
    },
  },
];
